import { ResponseDto } from '@diritto/common/base/response.dto';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { RollingApi } from 'api/ApiHelper';

export const useDeleteRollingMutation = (options?: UseMutationOptions<ResponseDto, unknown, { rollingId: number }>) =>
  useMutation({ mutationFn: ({ rollingId }) => RollingApi.deleteRolling(rollingId), ...options });
